<template>
    <div class="page__contact">
        <div class="page__wrapper">
            <div class="fader"></div>

            <Preloader />

            <Header />
            <section class="contact page_contact">
                <div class="content_wrapper">
                    <h1 class="contact__h1 detectMobVisibility">
                        <span class="textHide">
                            <span>{{ $t('contacts.title') }}</span>
                        </span>
                    </h1>
                    <div class="contact__content">
                        <div class="contact__item textFade detectMobVisibility" data-chain="1">
                            <h2 class="contact__h2">{{ $t('contacts.office') }}</h2>
                            <div class="contact__text" v-html="$t('contacts.adress')"></div>
                            <a
                                :href="directions"
                                :style=" directions ? '' : 'display: none' "
                                target="_blank"
                                rel="nofollow"
                                class="contact__link contact__link_gray spc_link"
                            >{{ $t('contacts.directions') }} →</a>
                            <a
                                v-for="(item, index) in phones"
                                :key="index"
                                :href="'tel:' + item"
                                class="contact__link contact__link_phone"
                            >{{ item }}</a>
                        </div>
                        <div class="contact__item textFade detectMobVisibility" data-chain="2">
                            <h2 class="contact__h2">{{ $t('contacts.email') }}</h2>
                            <a
                                v-for="(item, index) in emails"
                                :key="index"
                                :href="'mailto:' + item"
                                class="contact__link contact__link_email"
                            >{{ item }}</a>
                        </div>
                        <div class="contact__item textFade detectMobVisibility" data-chain="3">
                            <h2 class="contact__h2">{{ $t('contacts.careers') }}</h2>
                            <div class="contact__text">{{ $t('contacts.careers_descr') }}</div>
                            <a
                                :href="career"
                                :style=" career ? '' : 'display: none' "
                                target="_blank"
                                rel="nofollow"
                                class="contact__link contact__link_gray"
                            >{{ $t('contacts.openings') }} →</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from "jquery";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Preloader from "@/components/preloader.vue";
import params from "../../public/site_config.json";

export default {
    ComponentName: "contact",
    components: {
        Header,
        Footer,
        Preloader
    },
    data() {
        return {
            phones: params.phones,
            emails: params.emails,
            directions: params.directions_link,
            career: params.career_link
        };
    },
    created() {
        window.scrollTo(0, 0);
    },
    mounted() {
        var _this = this;

        $("body")
            .removeClass("faderIn hideTopBar")
            .addClass("lightBack scrolledPage contactPage faderOut");

        if ($("body").hasClass("contactPage")) {
            var scrollDelay = 0;
            $(window).scroll(function() {
                clearTimeout(scrollDelay);

                scrollDelay = setTimeout(function() {
                    _this.scrollDetect($(this).scrollTop());
                }, 150);
            });
        }
    },
    beforeDestroy() {
        $("body").addClass("lightBack scrolledPage contactPage");
    }
};
</script>

<style lang="stylus" scoped>
.content_wrapper {
    position: relative;
    background: none;
}

.page_contact {
    padding-top: 80px;
}

.contact {
    padding-bottom: 80px;

    @media (min-width: 1024px) {
        padding-left: 170px;
    }

    @media (min-width: 1600px) {
        padding-left: 150px;
    }
}

.contact__content {
    display: flex;
    flex-direction: column;

    @media (min-width: 1024px) {
        flex-flow: row wrap;
    }
}

.contact__item {
    display: flex;
    flex-direction: column;

    @media (min-width: 1024px) {
        width: 50%;
    }
}

.contact__h1 {
    font-weight: bold;
}

.contact__h2 {
    margin: 40px 0 16px;
}

.contact__text {
    line-height: 1.7;
    max-width: 70%;

    @media (min-width: 1024px) {
        max-width: 80%;
    }

    @media (min-width: 1330px) {
        max-width: 400px;
    }
}

.contact__link {
    color: inherit;
    margin: 8px 0;
}

.contact__link_gray {
    color: #999;

    &:hover {
        color: #000;
    }
}

.contact__link_email, .contact__link_phone {
    margin-top: 2px;
}

.spc_link {
    margin: 8px 0 16px;
}
</style>
